import CenterCenterVerticalContainer from '../../components/layout/CenterCenterVerticalContainer';
import AlertCard from '../../components/card/CardComponent';
import MainPageComponent from "../../components/page/MainPageComponent";
import './ApplicationStyle.css';


function NotFoundView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Página no encontrada', href: '' }
    ];

    return (
        <>
            <MainPageComponent requireAuthentication={false} path={breadcrumbPath} >
                <CenterCenterVerticalContainer>
                    <div className="d-flex flex-column flex-grow-1">
                        <AlertCard
                            text="Por favor verifica la dirección ingresada" title="La página que buscas no existe" buttonText="Página principal" navigate="/"
                        >
                        </AlertCard>
					</div>
                </CenterCenterVerticalContainer>
			</MainPageComponent>
        </>

    );
}

export default NotFoundView;